import styled from 'styled-components';
import {
  onSurface,
  onSurfaceVariant,
  outlineVariant,
  popoverShadow,
  primary,
  surface,
  surfaceContainer,
  surfaceHigh,
} from '../themeTokens';
import { CHROME_INSET_PX } from './chrome.constants';

export const NavSlot = styled.div`
  position: absolute;
  top: ${CHROME_INSET_PX}px;
  left: ${CHROME_INSET_PX}px;
  z-index: 3;
  pointer-events: auto;
`;

export const Toggle = styled.button<{ $open: boolean; $narrow: boolean }>`
  display: grid;
  place-items: center;
  width: ${(p) => (p.$narrow ? 32 : 40)}px;
  height: ${(p) => (p.$narrow ? 32 : 40)}px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: ${(p) => (p.$open ? surfaceHigh(p) : surface(p))};
  color: ${onSurface};
  font-size: ${(p) => (p.$narrow ? 16 : 20)}px;
  box-shadow: ${popoverShadow};
  cursor: pointer;

  &:hover {
    background: ${surfaceHigh};
  }

  &:focus-visible {
    outline: 2px solid ${primary};
    outline-offset: 2px;
  }
`;

export const Card = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: min(300px, calc(100cqw - ${CHROME_INSET_PX * 2}px));
  max-height: min(380px, calc(100cqh - 96px));
  overflow-y: auto;
  padding: 14px 10px 16px 16px;
  border-radius: 18px;
  background: ${surfaceContainer};
  color: ${onSurface};
  box-shadow: ${popoverShadow};
  scrollbar-width: thin;
  scrollbar-color: ${outlineVariant} transparent;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Heading = styled.h3`
  margin: 6px 0 2px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${onSurfaceVariant};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 34px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;

  & > svg {
    flex: none;
    font-size: 26px;
  }

  & [data-part] {
    color: ${primary};
  }
`;

export const Hint = styled.span`
  margin-left: 4px;
  font-weight: 400;
  color: ${onSurfaceVariant};
`;

export const Key = styled.kbd`
  flex: none;
  width: 96px;
  padding: 2px 8px;
  border-radius: 6px;
  background: ${surfaceHigh};
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
`;

export const KeyText = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: ${onSurfaceVariant};
`;
